<template>
  <div class="sidebar-box"
       ref="sidebar-box">
    <div class="sidebar-header" ref="sidebar-header">
      <template v-if="sidebarDataMapper && activeModuleDataMapper">
        <SidebarHeaderBox v-for="(
          value, index) in sidebarMapper[sbType].header"
                          :key="index"
                          :sbh-value=addSidebarHeaderValue(value)
                          :sbh-key="value"
                          :sbh-titles="sbType === 'tickets'
                          ? activeModuleData.titles[value] : sbHeaderTitles[value]">
        </SidebarHeaderBox>
      </template>
    </div>
    <div class="sidebar-content" ref="sidebar-content">
      <template v-if="sbData.data.length">
        <ContentBox :content-data="sbData.data"
                    :content-type="'sidebar'"
                    :content-comment="sidebarMapper[sbType].comment"
                    :content-titles="sbData.additionalTitles">
        </ContentBox>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import rulesProps from '../mixins';
import SidebarHeaderBox from './SidebarHeaderBox';
import ContentBox from './ContentBox';

export default {
  name: 'SidebarBox',
  components: { ContentBox, SidebarHeaderBox },
  data() {
    return {
      sidebarMapper: {
        tickets: {
          header: ['player_username', 'ticket_datetime'],
          forValueData: 'sidebarData',
          forTitleData: ['sidebarData', 'additionalTitles'],
          contentTable: true,
          comment: true,
        },
        events: {
          header: [],
          contentTable: true,
          comment: false,
        },
        results: {
          header: ['name', 'drawn_numbers', 'drawn_bonus_numbers'],
          forValueData: 'activeModuleData',
          forTitleData: ['activeModuleData', 'titles'],
          contentTable: true,
          comment: false,
        },
      },
    };
  },
  props: [
    'sbType',
    'sbData',
    'sbColumns',
    'sbHeaderData',
    'sbHeaderTitles',
  ],
  mixins: [rulesProps],
  computed: {
    ...mapGetters([
      'activeModuleData',
      'selectedRow',
      'sidebarDataMapper',
      'activeModuleDataMapper',
    ]),
  },
  methods: {
    calcContentHeight() {
      const haveHeader = this.sidebarMapper[this.sbType].header.length;
      if (!haveHeader) {
        this.$refs['sidebar-content'].style.height = '100%';
      } else if (this.$refs['sidebar-header']) {
        this.$refs['sidebar-content'].style.height = `calc(100% - ${this.$refs['sidebar-header'].clientHeight}px - 2px)`;
      } else {
        this.$nextTick(() => {
          this.calcContentHeight();
        });
      }
    },
    addSidebarHeaderValue(value) {
      let name = '';
      try {
        if (this.sbType === 'tickets') {
          if (this.activeModuleData.data.length && this.activeModuleData.data[this.selectedRow]) {
            name = this.activeModuleData.data[this.selectedRow][value];
          }
        } else {
          name = this.sbHeaderData[value];
        }
      } catch (e) {
        console.log(e);
      }
      return name;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.calcContentHeight();
    });
  },
  watch: {
    sbData() {
      this.calcContentHeight();
    },
  },
};
</script>

<style lang="scss" scoped>
  .sidebar-box {
    background-color: #fff;
    font-size: 14px;
    .sidebar-header {
      background-color: #007bcc;
      color: #fff;
      margin-bottom: 2px;
      padding: 20px 15px;
    }
    .sidebar-content {
      overflow: auto;
      width: 100%;
    }
  }
</style>
